import React, { FC } from 'react';
import styled from '@emotion/styled';
import { hideVisually } from 'polished';
import { Box, Link, Hide } from 'roo-ui/components';
import { HeaderDesktop } from './HeaderDesktop';
import { HeaderPhone } from './HeaderPhone';
import { HeaderProvider, HeaderProviderProps } from './HeaderContext';
import { themeGet } from 'styled-system';

export const Header: FC<HeaderProviderProps> = ({ ...rest }) => (
  <HeaderProvider {...rest}>
    <StickyHeader data-print-style="no-border">
      <VisibleOnFocus href="#content">
        Skip Global Header to Content
      </VisibleOnFocus>
      <Hide xs sm>
        <HeaderDesktop />
      </Hide>
      <Hide md lg>
        <HeaderPhone />
      </Hide>
    </StickyHeader>
  </HeaderProvider>
);

const StickyHeader = styled(Box)`
  top: 0;
  z-index: ${themeGet('zIndices.header')};
  background-color: ${themeGet('colors.white')};
`;

const VisibleOnFocus = styled(Link)`
  top: ${themeGet('space.2')};
  left: ${themeGet('space.2')};
  position: absolute;
  z-index: ${themeGet('zIndices.header')};
  :not(:focus) {
    ${hideVisually()};
  }
`;
